module.exports = __webpack_public_path__ + "media/img/new-8-374d6c95.png";